<ion-header mode="md" *ngIf="!isProtected">
  <ion-toolbar class="ion-text-center">
    <ion-item lines="none">
      <ion-img class="logo" src="../assets/images/app-logo.svg"></ion-img>
    </ion-item>
  </ion-toolbar>
</ion-header>

<app-header
  *ngIf="isProtected"
></app-header>

<ion-content full>
  <div class="box">
    <div class="content">
      <ion-item class="input" lines="none">
        <ion-back-button
          defaultHref="/auth/register"
          text=""
          *ngIf="!isProtected"
        ></ion-back-button>
        <h1>KLAUZULA INFORMACYJNA DOTYCZĄCA PRZETWARZANIA DANYCH OSOBOWYCH</h1>
      </ion-item>

      <div class="paragraph">
        <p>TOŻSAMOŚĆ ADMINISTRATORA</p>
        <div>
          Administratorem danych jest Space Technology Integrator Sp. Z o.o.
          Sp.k. z siedzibą w Warszawie (00-609) przy Al. Armii Ludowej 28.
        </div>
      </div>
      <div class="paragraph">
        <p>DANE KONTAKTOWE ADMINISTRATORA</p>
        <div>
          Z administratorem danych można się skontaktować poprzez adres
          odo&#64;space-tech.it, telefonicznie pod numerem: +48 22 656 21 23 lub
          pisemnie na adres siedziby Administratora.
        </div>
      </div>
      <div class="paragraph">
        <p>DANE KONTAKTOWE INSPEKTORA OCHRONY DANYCH</p>
        <div>
          Administrator wyznaczył inspektora ochrony danych, z którym może się
          Pani / Pan skontaktować poprzez e-mail odo&#64;space-tech.it,
          telefonicznie pod numerem +48 22 656 21 23 lub pisemnie na adres
          siedziby Administratora. Z inspektorem ochrony danych można się
          kontaktować we wszystkich sprawach dotyczących przetwarzania danych
          osobowych oraz korzystania z praw związanych z przetwarzaniem danych.
        </div>
      </div>
      <div class="paragraph">
        <p>DANE KONTAKTOWE ADMINISTRATORA</p>
        <div>
          Pani / Pana dane osobowe będą przetwarzane w celu:
          <ul>
            <li>
              założenia i obsługi konta klienta w serwisie wirtualnej recepcji;
            </li>
            <li>przyjmowania i realizacji zgłoszeń (awizacja gości);</li>
          </ul>
          Podstawą prawną przetwarzania Pani / Pana danych osobowych jest
          niezbędność do wykonania umowy.
        </div>
      </div>
      <div class="paragraph">
        <p>ODBIORCY DANYCH</p>
        <div>
          Pani / Pana dane osobowe mogą być przekazywane podmiotom
          przetwarzającym dane osobowe na zlecenie administratora: dostawcom
          usług IT.
        </div>
      </div>
      <div class="paragraph">
        <p>OKRES PRZECHOWYWANIA DANYCH</p>
        <div>
          Pani / Pana dane osobowe będą przetwarzane przez okres trwania umowy,
          aż do usunięcia konta w serwisie. Okres przechowywania danych
          osobowych może zostać każdorazowo przedłużony o okres przedawnienia
          roszczeń, jeżeli przetwarzanie danych osobowych będzie niezbędne do
          dochodzenia ewentualnych roszczeń lub do obrony przed takimi
          roszczeniami przez Administratora.
        </div>
      </div>
      <div class="paragraph">
        <p>PRAWA PODMIOTÓW DANYCH</p>
        <div>
          Przysługuje Pani / Panu prawo dostępu do Pani / Pana danych oraz prawo
          żądania ich sprostowania, ich usunięcia lub ograniczenia ich
          przetwarzania.
        </div>
      </div>
      <div class="paragraph">
        <p>PRAWO WNIESIENIA SKARGI DO ORGANU NADZORCZEGO</p>
        <div>
          Przysługuje Pani / Panu również prawo wniesienia skargi do organu
          nadzorczego zajmującego się ochroną danych osobowych w państwie
          członkowskim Pani / Pana zwykłego pobytu, miejsca pracy lub miejsca
          popełnienia domniemanego naruszenia.
        </div>
      </div>
      <div class="paragraph">
        <p>INFORMACJA O DOWOLNOŚCI LUB OBOWIĄZKU PODANIA DANYCH</p>
        <div>
          Podanie danych osobowych w celu założenia konta oraz następnie
          przyjmowania i realizacji zgłoszeń jest konieczne do zawarcia i
          wykonywania umowy – bez podania danych osobowych nie jest możliwe
          zawarcie umowy.
        </div>
      </div>
    </div>
  </div>
</ion-content>
